{
  "conflict": {
    "title": "Schedule Conflict Detected",
    "defaultMessage": "Another user has modified this aircraft's position. Your changes may override theirs.",
    "attemptProgress": "Attempt {{current}} of {{max}}",
    "retryExplanation": "• Retry will attempt to save your changes again, potentially overriding the other user's changes.",
    "cancelExplanation": "• Cancel will discard your changes and reload the current state.",
    "cancelButton": "Cancel Changes",
    "retryButton": "Retry Save"
  },
  "confirmation": {
    "defaultCancel": "Cancel",
    "defaultOk": "OK",
    "typeToConfirm": "Type 'delete' to confirm deletion.",
    "deletePlaceholder": "delete"
  },
  "progress": {
    "defaultItemName": "item",
    "processing": "Processing {{current}} of {{total}} {{itemName}}",
    "processingPlural": "Processing {{current}} of {{total}} {{itemName}}s",
    "currentLabel": "Current: {{currentItem}}"
  },
  "error": {
    "defaultTitle": "Oops! Something went wrong",
    "defaultDescription": "An unexpected error occurred.",
    "teamNotified": "The AirPlx team has been notified and is looking into it.",
    "errorDetailsLabel": "Error Details (dev only):",
    "componentStackLabel": "Component Stack",
    "refreshButton": "Refresh Page",
    "returnHome": "Return Home"
  },
  "notes": {
    "title": "Aircraft Notes",
    "label": "Notes",
    "placeholder": "Departure Time: 05/24/2025 12:00",
    "lastUpdate": "Last update: {{time}} ({{date}}) by {{user}}",
    "cancelButton": "Cancel",
    "saveButton": "Save"
  }
}
